import $ from "jquery";

let currentGallery = "";

/**
 * On hash change
 */
$(window).on("hashchange", (e) => {
    e.preventDefault();

    let hash = window.location.hash;

    if (hash) {
        // get hash and strip off first #
        hash = hash.slice(1);
        // split into an array
        let hashArray = hash.split("%");
        openGallery(hashArray);
    } else {
        // console.log('hash is ' + hash);
    }
});

/**
 * Hash on page load
 */
if (window.location.hash) {
    // get hash
    let hash = window.location.hash.slice(1);
    // split into an array
    let hashArray = hash.split("%");

    openGallery(hashArray);
}

/**
 * Function - Open Gallery
 * @param {Array} hashArray
 */
function openGallery(hashArray) {
    if (hashArray != null) {
        currentGallery = hashArray[0];
        let gallery = $(`[data-visuals-overlay="${hashArray[0]}"]`);

        if (gallery[0]) {
            let gallerySlick = $(gallery).find(".sb_visuals-overlay_slider");

            // console.log(gallery[0]);
            let openOnSLide = parseInt(hashArray[1]);

            $("body").addClass("s_is-open_visuals-overlay");
            gallery.addClass("s_active");

            setTimeout(() => {
                if (!gallerySlick.hasClass("slick-initialized")) {
                    // Check if slick settings are already applied via data-slick
                    let slickSettings = gallerySlick.attr("data-slick");

                    if (slickSettings) {
                        try {
                            let settings = JSON.parse(slickSettings);
                            gallerySlick.slick(settings);
                        } catch (e) {
                            console.warn(
                                "Invalid slick settings:",
                                slickSettings
                            );
                            gallerySlick.slick();
                        }
                    } else {
                        gallerySlick.slick();
                    }
                }
                gallerySlick.slick("slickGoTo", openOnSLide, true);
            }, 200);
        }
        gallery.on("afterChange", (event, slick, currentSlide) => {
            updateHash(`${currentGallery}%${currentSlide}`);
        });
    }
}

/**
 * Open event
 *
 * `data-visuals-open-overlay` holds the overlay id, `data-open-slide` the slide to open on. The
 * hash does the rest via the `hashchange` handler above. This used to live in
 * header-template.component.js, which the accommodation photos silently depended on.
 */
$("[data-visuals-open-overlay]").on("click tap", function (e) {
    e.preventDefault();

    const galleryID = $(this).attr("data-visuals-open-overlay");
    const openOnSlide = $(this).attr("data-open-slide");

    window.location.hash = `#${galleryID}%${openOnSlide}`;
});

/**
 * Close event
 */
$("[data-close-visuals-overlay]").on("click tap", (e) => {
    e.preventDefault();
    closeGallery();
});

/**
 * BG click
 */
$("body").on("click tap", ".sb_visuals-overlay_slide", (e) => {
    e.preventDefault();
    // console.log(e.target);
    if (
        $(e.target).hasClass("sb_visuals-overlay_slide") ||
        $(e.target).hasClass("sb_visuals-overlay_slide_container")
    ) {
        closeGallery();
    }
});

/**
 * Function - Close gallery
 */
function closeGallery() {
    $('[data-s-type="visuals-overlay"]').removeClass("s_active");
    $("body").removeClass("s_is-open_visuals-overlay");
    history.pushState(null, null, document.location.pathname);
    // Remove hash from url
    currentGallery = "";
}

/**
 * Update hash
 * @param {string} newHash
 */
function updateHash(newHash) {
    history.replaceState(
        null,
        null,
        `${document.location.pathname}#${newHash}`
    );
}

/**
 * Keyboard events
 */

$(document).on("keydown", (e) => {
    if (e.code === "ArrowRight") {
        if (currentGallery != "") {
            $(`[data-visuals-overlay="${currentGallery}"]`)
                .find(".slick-initialized")
                .slick("slickNext");
        }
    }
    if (e.code === "ArrowLeft") {
        if (currentGallery != "") {
            $(`[data-visuals-overlay="${currentGallery}"]`)
                .find(".slick-initialized")
                .slick("slickPrev");
        }
    }
    if (e.code === "Escape") {
        closeGallery();
    }
});
